import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { UserType } from 'types/user.types';

import { Dac7Modal } from './Dac7Modal';

const mapStateToProps = ({ userData }) => ({
  user: userData?.user,
  contact: userData?.contact,
});

type Props = {
  user: UserType;
  setShowDac7Modal?: (boolean) => void;
  onClose?: () => void;
};

const Dac7ModalContainer = (props: Props) => {
  const { user, setShowDac7Modal, onClose } = props;
  const [isOpen, setOpen] = useState(false);

  const closeModal = async () => {
    setOpen(false);
    setShowDac7Modal?.(false);
    onClose?.();
    localStorage.setItem('dac7ModalLastOpenAt', new Date().toISOString());
  };

  const showModal = async () => {
    setOpen(true);
  };

  useEffect(() => {
    if (user.dac7_required && !user.dac7_filled) {
      showModal();
    }
  }, [user?.isLoggedIn]);

  return isOpen && <Dac7Modal closeModal={closeModal} isOpen={isOpen} dac7RequiredAt={user.dac7_required_at} />;
};

export default connect(mapStateToProps)(Dac7ModalContainer);
